module.exports = __webpack_public_path__ + "static/media/etax-logo.4bc28ef3.png";